import {tv} from 'tailwind-variants'

export const hgFeaturedMediaVariants = tv({
  slots: {
    textBlock: 'col-span-full mt-s4',
  },
  variants: {
    alignment: {
      left: {
        textBlock: 'col-start-1 md:col-span-6 lg:col-start-3',
      },
      center: {
        textBlock: 'col-start-1 md:col-span-8 md:col-start-3 lg:col-start-5',
      },
    },
  },
})
